<style scoped>
.container-fluid#c1{
    height: 700px;
    background-image: url('../assets/images/bg1-2.png?20181011');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .container-fluid#c1 {
        background-attachment: scroll;
    }
}
@supports ( -ms-accelerator:true ) 
{
    html{
        overflow: hidden;
        height: 100%;    
    }
    body{
        overflow: auto;
        height: 100%;
    }
}
/*Ie 10/11*/
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) 
{
    html{
        overflow: hidden;
        height: 100%;    
    }
    body{
        overflow: auto;
        height: 100%;
    }
}
.title{
  color: white;
  font-size: 44px;
  font-family: 微軟正黑體;
}
.product-a{
  color:#000000;
}
.product-a:hover{
  color:#003567;
  text-decoration:none;
}
.block1{
  line-height: 30px;
}
.block1 svg{
    font-size: 75px;
    opacity: 0.8;
}
.block1:hover{
  color:	#004986;
}
.block1 p{
  color:	#5b5b5b;
}
.block1 p:hover{
  color:#004986;
}

.container-fluid#c2{
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
.news-text{
  font-family: 微軟正黑體;
}
.news_text{
  line-height: 35px;
  font-size: 16px;
  font-family: 微軟正黑體;
}
.news {
  margin-bottom: 30px;
  padding-bottom: 30px;
}

.news-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-text {
  word-wrap: break-word;
}

.news-style {
  font-family: 微軟正黑體;

  background: #EAECEE;
  padding: 15px 15px 0px 15px;
}

.news-img-style {
  background: #EAECEE;
}

#list {
  width: 100%;
  overflow: hidden;
}
.list_img{
  width: 100%;
  height:100%;
}
.news_a,.news_a:link,.news_a:visited{color:#000000;text-decoration: none}
</style>
<template>
    <div>
        <div class="container-fluid" id="c1">
            <div class="row">
                <div class="title offset-xl-5 offset-lg-5 offset-md-5">
                    <label class="p-5">
                        冠全資訊~~
                        <br>用單純的工具，將繁複的資料變為簡單
                    </label>
                </div>
            </div>
        </div>
        <div class="container-fluid py-5" id="c2">
           <div id="carousel-demo" class="carousel slide news-style border rounded mt-5" data-keyboard="false" data-interval="5000" data-pause="false" data-ride="carousel">
                <ol class="carousel-indicators">
                    <li data-target="#carousel-demo" :data-slide-to="index" :class="{'active':index==0}" v-for="(item , index) in news" :key="item.id"></li>
                </ol>
                <div class="carousel-inner mt-4 mb-4">
                    <div class="carousel-item" :class="{'active':index==0}" v-for="(item , index) in news" :key="item.id">
                        <router-link :to="`/news/${item.id}`" style="text-decoration:none;" class="news_a news_a_2">
                            <div class="row news justify-content-around" >
                                <div class="col-md-5 col-sm-4">
                                    <slick
                                        ref="slick"
                                        :options="slickOptions">
                                        <div v-for="img in item.images" :key="img.id">
                                            <img class="list_img" :src="`${route}/${img.name}`" alt="">
                                        </div>
                                    </slick>
                                </div>
                                <div class="container col-md-7 col-sm-8">
                                    <div class="news-text">
                                        <h3 class="text-left">{{item.title}}</h3>
                                        <hr>
                                        <div class="text-left news_text" v-html="htmldecode(item.content)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="container-fluid pb-5" id="c5">
            <div class="row text-center">
                <div class="mt-5 mb-5 mx-auto col-md-4">
                    <h1>產品介紹</h1>
                </div>
            </div>
            <div class="container">
                <div class="row justify-content-around">

                    <div class="col-lg-2  col-sm-4 col-6 block1 mb-5">
                        <router-link to="/product/hotel" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon :icon="['fas', 'hotel']"/>
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>飯店PMS</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 mb-5">
                        <router-link to="/product/pos" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon :icon="['fas', 'utensils']" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>餐廳POS</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 mb-5">
                        <router-link to="/product/purchase" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="shopping-cart" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>採購庫存</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 mb-5">
                        <router-link to="/product/booking" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="calendar-alt"/>
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>訂席系統</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 mb-5">
                        <router-link to="/product/member" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="user-circle" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>會員管理</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 mb-5">
                        <router-link to="/product/humanresource" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="users" size="5x"/>
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>人資管理</b></h5>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row justify-content-around">
                    <div class="col-lg-2  col-sm-4 col-6 block1 pb-5">
                        <router-link to="/product/finance" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="hand-holding-usd" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>財務管理</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 pb-5">
                        <router-link to="/product/fix" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="wrench" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>工程維修</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 pb-5">
                        <router-link to="/product/securities" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="ticket-alt" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>票券管理</b></h5>

                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 pb-5">
                        <router-link to="/product/combine" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="cogs" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>整合管理</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 pb-5">
                        <router-link to="/product/phone" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="mobile-alt" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>行動裝置</b></h5>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-lg-2  col-sm-4 col-6 block1 pb-5">
                        <router-link to="/product/sale" class="product-a">
                            <div class="text-center w-75 h-45 ml-4 mb-4">
                                <font-awesome-icon icon="dolly-flatbed" />
                            </div>
                            <div class="mt-2 text-center">
                                <h5><b>商品銷售</b></h5>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script >
import $ from 'jquery'
export default {
    data(){
        return{
            news:null,
            route:null,
            slickOptions: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 1500,
            },
        }
    },
    mounted(){
        const self =this;

        $('#carousel-demo').on('slide.bs.carousel', function (e) {
            self.reSlick(e.to);
            self.pause(e.from);
        })
        this.$http.get(`https://www.kcsys.com.tw/kcsys/public/api/v1/news/getThreeNews`)
        .then((response) => {
            self.news = response.data.data;
            self.route = response.data.route;
        })
    },
    methods:{
        reSlick:function(id){
            this.$nextTick(() => {
                this.$refs.slick[id].reSlick();
            });
        },
        pause:function(id) {
            this.$nextTick(() => {
                this.$refs.slick[id].pause();
            });
        },
        htmldecode:function(s){
            var div = document.createElement('div');
            div.innerHTML = s;
            return div.innerText || div.textContent;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue